import cn from 'classnames';

import Image from '../Image';

import styles from './PatternBackground.module.scss';

export type PatternBackgroundProps = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  theme?: 'light' | 'dark';
  fetchPriority?: 'high' | 'low' | 'auto';
};

const PatternBackground = (props: PatternBackgroundProps): JSX.Element => {
  const { className, fetchPriority = 'low', size = 'large', theme = 'dark' } = props;

  const src =
    size === 'small' && theme === 'dark'
      ? '/images/pattern-small-dark.jpg'
      : `/images/pattern-${size}-${theme}.png`;

  return (
    <Image
      className={cn(styles.main, className)}
      src={src}
      alt=""
      fill
      fetchPriority={fetchPriority}
    />
  );
};

export default PatternBackground;
